import useDashboardContext from 'contexts/dashboard.context';
import useOrdersContext from 'contexts/orders.context';
import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const Basket = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { setBackLinkTitle, setIsBackLink } = useDashboardContext();
  const { handleReset } = useOrdersContext();

  useEffect(() => {
    const isNotGroup = pathname !== ROUTE_KEYS.GROUP_BASKET;
    const isNotBulk = pathname !== ROUTE_KEYS.BULK_BASKET;
    const isNotBatch = pathname !== ROUTE_KEYS.BATCH_BASKET;
    if (isNotGroup && isNotBulk && isNotBatch) {
      handleReset();
      navigate(`/${ROUTE_KEYS.ORDERS}`);
    }
    setIsBackLink(true);
    setBackLinkTitle('Return to Previous');
  }, [pathname]);

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Basket;
